type KeywordLinkSource = {
  mapsSearchUrl?: string | null;
  searchUrl?: string | null;
  title?: string | null;
};

/**
 * Link do "Ver link" de uma palavra chave. Só devolve URL que o Radar gravou:
 * a busca do ranqueamento e, na falta dela, a ficha do próprio cliente.
 * Sem nenhuma das duas o botão não aparece — montar "maps/search/<título>"
 * fazia o Google resolver a busca na ficha de outra empresa.
 */
export const linkDaConsulta = ({
  mapsSearchUrl,
  searchUrl,
}: KeywordLinkSource): string | null => {
  const gravado = [mapsSearchUrl, searchUrl].find(
    (url) => typeof url === "string" && url.trim().length > 0,
  );
  return gravado ?? null;
};
